// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Unarchive = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Unarchive = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Unarchive = _exports.Unarchive = function Unarchive(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20",
      fill: "none"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M1.875 3.125V5H18.125V3.125H1.875ZM1.25 1.25H18.75C19.4414 1.25 20 1.80859 20 2.5V5.625C20 6.31641 19.4414 6.875 18.75 6.875H1.25C0.558594 6.875 0 6.31641 0 5.625V2.5C0 1.80859 0.558594 1.25 1.25 1.25ZM1.25 16.25V8.125H3.125V16.25C3.125 16.5938 3.40625 16.875 3.75 16.875H16.25C16.5938 16.875 16.875 16.5938 16.875 16.25V8.125H18.75V16.25C18.75 17.6289 17.6289 18.75 16.25 18.75H3.75C2.37109 18.75 1.25 17.6289 1.25 16.25Z",
      fill: "currentColor"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M10.0019 8.26172C9.79763 8.26172 9.60068 8.3419 9.45618 8.48929L6.50814 11.49C6.2185 11.7857 6.23531 12.2496 6.53961 12.5259C6.8407 12.7993 7.31319 12.7832 7.59745 12.4959L9.24921 10.8149V14.9923C9.24921 15.4042 9.59336 15.7218 10.0019 15.7218C10.4105 15.7218 10.7547 15.4042 10.7547 14.9923V10.8149L12.4041 12.4937C12.6895 12.7849 13.1619 12.7962 13.462 12.5237C13.7657 12.2478 13.7834 11.7812 13.4927 11.487L10.5478 8.48941C10.4033 8.34195 10.2063 8.26172 10.0019 8.26172Z",
      fill: "currentColor"
    }));
  };
});
